<script setup lang="ts">
import { nftService } from '~/api/service/nft.service'
import DetailsBox from '~/components/box/DetailsBox.vue'
import { NFT_TRANSFER_COLUMN } from '~/components/table/tokens-transfer/tokensTransferColumn.const'
import TokensTransferTable from '~/components/table/tokens-transfer/TokensTransferTable.vue'
import { useTokenType } from '~/composables/useTokenType'
import { INftType } from '~/types/token-type.type'
import BcPagination from '~/ui/Pagination/BcPagination.vue'
import { getBreadCrumb } from '~/utils/breadCrumbList'
import { getRouteParam } from '~/utils/route.util'

const { tokenTypeValue } = useTokenType<INftType>()

const address = getRouteParam('address')

const { pagination, rowPerPageList } = usePagination({
  page: 1,
  rowPerPage: 25,
}, false)

const transferListFunction = {
  [INftType.ERC721]: nftService.useGetNftErc721TransferList,
  [INftType.ERC1155]: nftService.useGetNftErc1155TransferList,
}

const { data, isLoading } = transferListFunction[tokenTypeValue](pagination, address)

useHead(getBreadCrumb())
</script>

<template>
  <DetailsBox>
    Showing all <span class="text-primary">{{ data?.formattedTotalCount }}</span> results
    <template #pagination>
      <BcPagination
        v-model="pagination"
        :row-per-page-list="rowPerPageList"
        :total-count="data?.viewCount"
        hide-rows-per-page
      />
    </template>
  </DetailsBox>
  <Card>
    <TokensTransferTable
      :rows="data?.transferList || []"
      :is-loading="isLoading"
      :row-cnt="pagination.rowPerPage"
      :columns="NFT_TRANSFER_COLUMN"
    />
    <BcPagination
      v-model="pagination"
      :row-per-page-list="rowPerPageList"
      :total-count="data?.viewCount"
    />
  </Card>
</template>

<style scoped lang="scss">

</style>
